<template>
  <div class="login-page flex-center position-ref full-height">
    <div class="content">
      <div class="title m-b-md">SAXX Acadia</div>

      <div class="links">
        <button @click="login" class="btn btn-dark">Login</button>

        <a href="/privacy-policy">Privacy Policy</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Login",
    beforeDestroy() {
      if (this.oauthWindow) {
        this.oauthWindow.removeEventListener('message', this.listener);
        this.oauthWindow = null;
      }
    },
    data() {
      return {
        oauthWindow: null,
      };
    },
    methods: {
      login() {
        this.createPopup('/login/azure');
      },
      createPopup(url) {
        const name = '';
        const width = 500;
        const height = 500;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2.5;

        const windowFeatures = `toolbar=0,scrollbars=1,status=1,resizable=0,location=1,menuBar=0,width=${width},height=${height},top=${top},left=${left}`;
        this.oauthWindow = window.open(url, name, windowFeatures);

        // Hacky way to ensure everything works
        const interval = setInterval(() => {
          if (this.oauthWindow.closed) {
            clearInterval(interval);
            
            let redirect = null;
            if (localStorage) {
              redirect = localStorage.getItem('redirect_after_oauth');
              if (redirect) {
                localStorage.removeItem('redirect_after_oauth');
              }
            }
            
            window.location.href = redirect;
          }
        }, 1000);

        this.oauthWindow.focus();
      },
    }
  };
</script>

<style scoped>
  .login-page {
    background-color: #fff;
    color: #636b6f;
    font-family: "Raleway", sans-serif;
    font-weight: 100;
    height: 100vh;
    margin: 0;
  }

  .btn-dark {
    color: #fff;
    background-color: #343a40;
  }

  .full-height {
    height: 100vh;
  }

  .flex-center {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .position-ref {
    position: relative;
  }

  .top-right {
    position: absolute;
    right: 10px;
    top: 18px;
  }

  .content {
    text-align: center;
  }

  .title {
    font-size: 84px;
  }

  .links > a {
    color: #636b6f;
    padding: 0 25px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.1rem;
    text-decoration: none;
    text-transform: uppercase;
  }

  .m-b-md {
    margin-bottom: 30px;
  }

  .content {
    -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadein 2s; /* Firefox < 16 */
    -ms-animation: fadein 2s; /* Internet Explorer */
    -o-animation: fadein 2s; /* Opera < 12.1 */
    animation: fadein 2s;
  }

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Firefox < 16 */
  @-moz-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Safari, Chrome and Opera > 12.1 */
  @-webkit-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Internet Explorer */
  @-ms-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Opera < 12.1 */
  @-o-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
</style>